<template>
  <div id="app">
    <router-view/>
   
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      active: 0
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100vh;
}
</style>
